<div class="form-skeleton-root" aria-busy="true" aria-live="polite">
  <span class="sr-only">Loading…</span>

  @if (showHeader) {
    <div class="mb-6 space-y-2">
      <div class="form-skeleton h-6 w-64 max-w-full rounded-md"></div>
      <div class="form-skeleton h-4 w-80 max-w-full rounded-md"></div>
    </div>
  }

  @if (cardItems.length) {
    <div class="mb-6 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
      @for (_ of cardItems; track $index) {
        <div class="rounded-xl border border-slate200 bg-white p-4">
          <div class="form-skeleton mb-3 h-9 w-9 rounded-full"></div>
          <div class="form-skeleton mb-2 h-3 w-16 rounded-md"></div>
          <div class="form-skeleton h-5 w-24 max-w-full rounded-md"></div>
        </div>
      }
    </div>
  }

  @if (fieldItems.length) {
    <div class="grid grid-cols-1 gap-x-6 gap-y-5" [ngClass]="gridColumnsClass">
      @for (_ of fieldItems; track $index) {
        <div class="space-y-2">
          <div class="form-skeleton h-3 w-28 max-w-full rounded-md"></div>
          <div class="form-skeleton h-10 w-full rounded-lg"></div>
        </div>
      }
    </div>
  }
</div>
